module.exports = __webpack_public_path__ + "static/media/Resume.ee8799d2.pdf";